import React from 'react';
// import PropTypes from 'prop-types';

import { PageWrapper, ContentWrapper } from 'bumblebee-ui';
import { useLazyDownloadTemplateDocumentQuery } from '../../../redux/reducers/documents';

const config = stateConfig;

const Resources = () => {
  const [getTemplateDocuments] = useLazyDownloadTemplateDocumentQuery();

  let headerText = 'Helpful Links';
  if (config.state === 'Mississippi') {
    headerText = 'HAF Status Dashboard';
  }
  if (config.state === 'Georgia') {
    headerText = 'Georgia Mortgage Assistance Resources';
  }
  if (config.state === 'Nebraska') {
    headerText = ' ';
  }
  if (config.state === 'Missouri') {
    headerText = 'Resources';
  }
  if (config.state === 'New Jersey') {
    headerText = 'Housing Counselors';
  }
  if (config.state === 'Indiana') {
    headerText = 'Homeowner Resources';
  }

  return (
    <PageWrapper>
      <ContentWrapper
        headerDesc={<p className='fw-bold mb-0'>{config.programName}</p>}
        header={headerText}
      >
        <div dangerouslySetInnerHTML={{ __html: config.staticPages.resources.content }} />

        {config.state === 'Indiana' && (
          <p className='text-primary pointer' onClick={() => getTemplateDocuments('PP')}>Download</p>
        )}
      </ContentWrapper>
    </PageWrapper>
  );
};

Resources.propTypes = {
};

export default Resources;
